<template>

  <div id="detailsHeader">
    <v-btn flat fab small class="vo-icon-button left" @click="closeDetails">
      <v-icon medium>mdi-arrow-left</v-icon>
    </v-btn>

    <v-btn fab flat small v-if="rightButton && page.selected" class="vo-icon-button right" @click="rightButtonClicked">
      <v-icon medium>{{ rightButton.icon }}</v-icon>
    </v-btn>
  </div>

</template>

<script>

  export default {
    data () {
      return {

      }
    },
    props: {
      rightButton: {
        type: Object
      },
      page: {
        type: Object
      }
    },
    methods: {
      closeDetails () {
        // var query = this.$route.query;
        // delete query.details;
        this.$router.replace({
          query: {}
        });

      },
      rightButtonClicked () {
        this.routeAddQuery(this.rightButton.query);
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #detailsHeader {
    position: relative;
    width: 100%;
    height: 48px;
    border-bottom: $borderBlack12;
    background: $white;

    .vo-icon-button.left {
      display: none;
    }

    .vo-icon-button.right {
      display: none;
    }

    @media screen and (max-width: 1480px) {

      .vo-icon-button.right {
        display: block;
        position: absolute;
        top: 3px;
        right: 3px;
        bottom: 0;
        margin: 0;
      }
    
    }

    @media screen and (max-width: 768px) {
      
      .vo-icon-button.left {
        display: block;
        position: absolute;
        top: 3px;
        left: 3px;
        bottom: 0;
        margin: 0;
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/DetailsHeader.vue